import { render, staticRenderFns } from "./Landings.vue?vue&type=template&id=affaa6be"
import script from "./Landings.vue?vue&type=script&lang=js"
export * from "./Landings.vue?vue&type=script&lang=js"
import style0 from "./Landings.vue?vue&type=style&index=0&id=affaa6be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports